const historyActionTypes = {
  SET_SPACE_ID: "SET_SPACE_ID",
  SET_STATION_ID: "SET_STATION_ID",
  SET_FOLDER_ID: "SET_FOLDER_ID",
  SET_IDS_NULL: "SET_IDS_NULL",
  SET_LOADING: "SET_LOADING",
};

export default historyActionTypes;
